import { useAnimation } from 'framer-motion';
import { theme } from '@frameio/vapor';

const ROW_TRANSITION_TIMING = 0.6;
const backgroundAsTransparent = 'transparent';

/**
 * Provides the useAnimation controls and animation callbacks for use with the
 * InviteAccessMemberList
 */
export const useRowAnimationControls = () => {
  const rowControls = useAnimation();

  async function animateRowOut(memberIdToDelete: string) {
    await rowControls.start((memberId: string) =>
      memberIdToDelete === memberId
        ? {
            opacity: [1, 1, 0],
            height: '0px',
            overflow: 'hidden',
            transition: {
              duration: ROW_TRANSITION_TIMING,
              ease: theme.transitions.curves.primary,
            },
          }
        : {}
    );

    return rowControls.stop();
  }

  async function animateRowIn(memberIdToAdd: string) {
    await rowControls.start((memberId: string) =>
      memberIdToAdd === memberId
        ? {
            backgroundColor: [
              theme.colors.background.interactive.pressed,
              theme.colors.background.interactive.pressed,
              backgroundAsTransparent,
            ],
            height: '51px',
            opacity: [0, 1, 1],
            overflow: 'hidden',
            transition: {
              duration: ROW_TRANSITION_TIMING,
              ease: theme.transitions.curves.primary,
            },
            transitionEnd: {
              overflow: 'visible',
              height: 'auto',
            },
          }
        : {}
    );

    return rowControls.stop();
  }

  return { animateRowIn, animateRowOut, rowControls };
};
